import React from 'react'
import ReactHTMLParser from 'react-html-parser'
import Moment from 'moment'

import { applyColor } from 'utils/apply-color'
import { getSelectedLanguageContent, handleNestedObjectKey, numberWithCommas, truncateTextWithEllipsis } from 'utils'
import _ from 'lodash'

const TechBaseText = props => {
  let {
    content,
    dataKey,
    style,
    className,
    variant,
    suffix,
    prefix,
    decimalPoint,
    showEmptyData,
    maxChars,
    shortform,
    showShortForm,
    textToList,
    valueType
  } = props.item

  const textToListFunc = (text) => {
    const items = _.split(text, '</br>');
    const filteredItems = _.filter(items, Boolean);
    const listItems = _.map(filteredItems, item => {
      const subItems = _.split(item, '<li>')
      const filteredSubItems = _.filter(subItems, Boolean)
      if( filteredSubItems.length > 1 ) {
        const firstElement = filteredSubItems.shift()
        const listSubItems = _.map(filteredSubItems, subItem => `<li>${subItem}</li>`);
        return `<li>${firstElement}<ul className="text-sm text-black leading-5 jombiz-package-sub-list">\n${listSubItems.join('\n')}\n</ul></li>`
      } else {
        return `<li>${item}</li>`
      }
    });
    const htmlList = `\n${listItems.join('\n')}\n`;
    return htmlList
  }

  const getContent = () => {
    if( dataKey ){
      let tmpData = handleNestedObjectKey( props, dataKey )
      if( _.isEmpty( tmpData ) && typeof tmpData !== 'number' && !showEmptyData ){
        return ''
      }
      if( variant === "price" && typeof tmpData === "number" ){
        tmpData = tmpData.toFixed(2)
        if( !_.isEmpty( tmpData ) ){
          tmpData = `${ tmpData.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
        }
      }
      if( typeof tmpData === "number" && variant === "number" ){
        tmpData = tmpData.toFixed( decimalPoint || 0 )
      }
      if( variant === "date" && Moment( tmpData ).isValid() && typeof tmpData !== "number" ){
        tmpData = Moment( tmpData ).format( 'DD-MM-YYYY' )
      }
      if( variant === "datetime" && Moment( tmpData ).isValid() && typeof tmpData !== "number" ){
        tmpData = Moment( tmpData ).format( 'DD-MM-YYYY HH:MM:SS' )
      }
      if( variant === 'numberWithComma' ) {
        tmpData = numberWithCommas( tmpData )
      }
      if( prefix || suffix ) {
        tmpData = `${ getSelectedLanguageContent( handleNestedObjectKey( props, prefix ) || prefix, props.selectedLanguage ) } ${ getSelectedLanguageContent( tmpData, props.selectedLanguage ) } ${ getSelectedLanguageContent( handleNestedObjectKey( props, suffix ) || suffix, props.selectedLanguage ) }`
      } else {
        tmpData = `${ getSelectedLanguageContent( tmpData, props.selectedLanguage )}`
      }
      if (valueType === 'translate') {
        tmpData = getSelectedLanguageContent(`{{${tmpData}}}`, props.selectedLanguage)
      }
      if( tmpData === 'member007' ) {
        tmpData = 'JombizStoreHQ'
      }
      if( content ){
        let tmp = getSelectedLanguageContent( content, props.selectedLanguage )
        return tmp.replaceAll("${PLACEHOLDER}", tmpData).replaceAll("{PLACEHOLDER}", tmpData)
      } else {
        return getSelectedLanguageContent( tmpData || '-', props.selectedLanguage )
      }
    } else if( shortform && typeof showShortForm === 'function' && showShortForm()) {
      return getSelectedLanguageContent( shortform, props.selectedLanguage )
    } else {
      return getSelectedLanguageContent( content, props.selectedLanguage )
    }
  }
  
  return (
    <div 
      style={ applyColor( style, props.colors ) }
      className={ className || '' }
    >
      {
        textToList ?
          ReactHTMLParser (
            textToListFunc (
              truncateTextWithEllipsis( applyColor( getContent(), props.colors ), maxChars )
            )
          ) :
          ReactHTMLParser (
            truncateTextWithEllipsis( applyColor( getContent(), props.colors ), maxChars )
          )
      }
    </div>
  )
}

export default TechBaseText